import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AuthEffects } from '@effects/auth/auth.effect';
import { ContactsEffects } from '@effects/contacts/contacts.effect';
import { HomeEffects } from '@effects/home/home.effect';
import { UsersEffects } from '@effects/users/users.effect';
import { LocationEffects } from '@effects/locations/locations.effect';
import { BusinessEffects } from '@effects/business/business.effect';
import { ResellersEffects } from '@effects/resellers/resellers.effects';
import { ReviewTargetsEffects } from '@effects/review-targets/review-targets.effects';
import { FacebookEffects } from '@effects/facebook/facebook.effects';
import { CampaignEffects } from '@effects/campaigns/campaigns.effect';
import { ReviewsEffects } from '@effects/reviews/reviews.effects';
import { FeedbacksEffects } from '@effects/feedbacks/feedbacks.effects';
import { ContactHistoryEffects } from '@effects/contactHistory/contactHistory.effect';
import { WidgetsEffects } from '@effects/widgets/widgets.effects';
import { DashboardsEffects } from '@effects/dashboards/dashboards.effects';
import { ReportsEffects } from '@effects/reports/reports.effects';
import { GMBEffects } from '@effects/gmb/gmb.effects';
import { RouterEffects } from '@effects/router.effects';
import { AppEffects } from '@effects/app.effects';
import { ReplyTemplateEffects } from '@effects/reply-template.effects';

import { ROOT_REDUCERS, metaReducers } from '@reducers/index'
import { HeaderInterceptor } from './interceptors/header.interceptor';
import { ValidateOperationInterceptor } from './interceptors/validateOperation.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LoggerRequestInterceptor } from './interceptors/logger-request.interceptor';


@NgModule({
  declarations: [
  ],
  imports: [
    BrowserModule,
    StoreModule.forRoot(ROOT_REDUCERS, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
        strictStateSerializability: false,
        strictActionSerializability: false,
      },
    }),
    EffectsModule.forRoot([
      AuthEffects,
      ContactsEffects,
      HomeEffects,
      RouterEffects,
      UsersEffects,
      LocationEffects,
      BusinessEffects,
      ResellersEffects,
      ReviewTargetsEffects,
      FacebookEffects,
      CampaignEffects,
      ReviewsEffects,
      FeedbacksEffects,
      ContactHistoryEffects,
      WidgetsEffects,
      DashboardsEffects,
      ReportsEffects,
      GMBEffects,
      AppEffects,
      ReplyTemplateEffects
    ])
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ValidateOperationInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoggerRequestInterceptor,
      multi: true
    }
  ]
})
export class CoreModule { }
